import { render } from "./LoadedFilesList.vue?vue&type=template&id=0cfdd55c"
import script from "./LoadedFilesList.vue?vue&type=script&lang=js"
export * from "./LoadedFilesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__